import * as React from 'react';
import {BaseIconProps} from '../../types';

export const BaseComment: React.FC<BaseIconProps> = ({color, size}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.62195 18.4895C3.95543 17.9985 4.23574 17.4685 4.4546 16.9077C3.53462 15.4962 3 13.8105 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C10.1233 21 8.38078 20.4256 6.93863 19.443C6.13827 19.7593 5.27468 19.9503 4.37206 19.9917C4.24852 19.9974 4.12424 20.0003 3.9993 20.0003C3.47104 20.0003 2.95473 19.9491 2.45508 19.8513C2.89275 19.4431 3.28456 18.9863 3.62195 18.4895ZM6.7506 21.0953C8.29564 21.9887 10.0898 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 13.8091 1.95866 15.5144 2.7663 17.0025C2.42327 17.6597 1.97059 18.252 1.4319 18.7545C1.01969 19.139 0.857869 19.7222 1.01299 20.2641C1.1681 20.806 1.61397 21.2153 2.16719 21.3235C2.76118 21.4396 3.37389 21.5003 3.9993 21.5003C4.95423 21.5003 5.87832 21.3589 6.7506 21.0953ZM13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12ZM9.25 12C9.25 12.6904 8.69036 13.25 8 13.25C7.30964 13.25 6.75 12.6904 6.75 12C6.75 11.3096 7.30964 10.75 8 10.75C8.69036 10.75 9.25 11.3096 9.25 12ZM17.25 12C17.25 12.6904 16.6904 13.25 16 13.25C15.3096 13.25 14.75 12.6904 14.75 12C14.75 11.3096 15.3096 10.75 16 10.75C16.6904 10.75 17.25 11.3096 17.25 12Z"
        fill={color}
      />
    </svg>
  );
};
